import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getThemePrimaryColor, getThemeVariant } from '../../modules/configuration/selectors';
import { ApplicationState } from '../../types';
import { ThemeWrapper, ThemeWrapperProps } from './ThemeWrapper';

export const ThemeProvider = connect<ThemeWrapperProps, {}, {}, ApplicationState>(
    createStructuredSelector({
        primaryColor: getThemePrimaryColor,
        variant: getThemeVariant,
    })
)(ThemeWrapper) as $TSFixMe;
